import { FileExcelOutlined, FileImageOutlined, FileOutlined, FilePdfOutlined, FileWordOutlined } from "@ant-design/icons";
import { GrDocumentPdf } from "react-icons/gr";
import { FaFilePdf } from "react-icons/fa6";
import { SiMicrosoftexcel } from "react-icons/si";
import { AiOutlineFileJpg } from "react-icons/ai";
import { BsFileEarmarkWordFill } from "react-icons/bs";
import { SiMicrosoftword } from "react-icons/si";
import { RiFilePpt2Fill } from "react-icons/ri";
import { componentPalette } from "src/theme/component-palette";

const FileIcons = ({ fileName }: { fileName: string }) => {
  const extension = fileName.split(".").pop()?.toLowerCase();
  switch (extension) {
    case "pdf":
      return <FaFilePdf style={{ color: componentPalette.pdfColor, fontSize: "25px" }} />;
    case "doc":
    case "docx":
      return <SiMicrosoftword style={{ color: componentPalette.wordColor, fontSize: "25px" }} />;
    case "xls":
    case "xlsx":
      return <SiMicrosoftexcel style={{ color: componentPalette.excelColor, fontSize: "25px" }} />;
    case "jpg":
    case "jpeg":
    case "png":
      return <AiOutlineFileJpg style={{ color: "black", fontSize: "25px" }} />;
    case "pptx":
    case "ppt":
      return <RiFilePpt2Fill style={{ color: componentPalette.pptxColor, fontSize: "25px" }} />;
    default:
      return <FileOutlined style={{ fontSize: "25px" }} />;
  }
};
export default FileIcons;
